"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Table.css");
var _dist = require("package_ui_ihm/dist");
var _Table2 = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _IconActivation = _interopRequireDefault(require("./IconActivation"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : EquipmentConfig.js
* Description : Ce fichier contient la définition du composant EquipmentConfig 
*               Ce composant affiche un tableau avec les informations des sous-ensembles d'un produit client
* Date de création : 14 mars 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* EquipmentConfig : ce composant affiche un tableau avec les informations des sous-ensembles d'un produit client
*
* Type : composant 
*
* Parametres : 
*  - equipment -- produit client
*  - ptus -- sous ensemble : PTU d'un boxitunnel, d'un boxilab ou d'un boxistick
*  - setReload -- 
*/
function EquipmentConfig(_ref) {
  var equipment = _ref.equipment,
    ptus = _ref.ptus,
    setReload = _ref.setReload;
  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    cpuBox = _useState2[0],
    setCpuBox = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    changeCpuBox = _useState4[0],
    setChangeCpuBox = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCpuBox = _useState6[0],
    setSelectedCpuBox = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    cpuBoxes = _useState8[0],
    setCpuBoxes = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    removeCpuBoxStatus = _useState0[0],
    setRemoveCpuBoxStatus = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    addCpuBoxStatus = _useState10[0],
    setAddCpuBoxStatus = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    powerBox = _useState12[0],
    setPowerBox = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    changePowerBox = _useState14[0],
    setChangePowerBox = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedPowerBox = _useState16[0],
    setSelectedPowerBox = _useState16[1];
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    powerBoxes = _useState18[0],
    setPowerBoxes = _useState18[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    removePowerBoxStatus = _useState20[0],
    setRemovePowerBoxStatus = _useState20[1];
  var _useState21 = (0, _react.useState)(null),
    _useState22 = _slicedToArray(_useState21, 2),
    addPowerBoxStatus = _useState22[0],
    setAddPowerBoxStatus = _useState22[1];
  var _useState23 = (0, _react.useState)(null),
    _useState24 = _slicedToArray(_useState23, 2),
    tunnelBox = _useState24[0],
    setTunnelBox = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    changeTunnelBox = _useState26[0],
    setChangeTunnelBox = _useState26[1];
  var _useState27 = (0, _react.useState)(0),
    _useState28 = _slicedToArray(_useState27, 2),
    selectedTunnelBox = _useState28[0],
    setSelectedTunnelBox = _useState28[1];
  var _useState29 = (0, _react.useState)([]),
    _useState30 = _slicedToArray(_useState29, 2),
    tunnelBoxes = _useState30[0],
    setTunnelBoxes = _useState30[1];
  var _useState31 = (0, _react.useState)(null),
    _useState32 = _slicedToArray(_useState31, 2),
    removeTunnelBoxStatus = _useState32[0],
    setRemoveTunnelBoxStatus = _useState32[1];
  var _useState33 = (0, _react.useState)(null),
    _useState34 = _slicedToArray(_useState33, 2),
    addTunnelBoxStatus = _useState34[0],
    setAddTunnelBoxStatus = _useState34[1];
  var _useState35 = (0, _react.useState)(null),
    _useState36 = _slicedToArray(_useState35, 2),
    roverBox = _useState36[0],
    setRoverBox = _useState36[1];
  var _useState37 = (0, _react.useState)(false),
    _useState38 = _slicedToArray(_useState37, 2),
    changeRoverBox = _useState38[0],
    setChangeRoverBox = _useState38[1];
  var _useState39 = (0, _react.useState)(0),
    _useState40 = _slicedToArray(_useState39, 2),
    selectedRoverBox = _useState40[0],
    setSelectedRoverBox = _useState40[1];
  var _useState41 = (0, _react.useState)([]),
    _useState42 = _slicedToArray(_useState41, 2),
    roverBoxes = _useState42[0],
    setRoverBoxes = _useState42[1];
  var _useState43 = (0, _react.useState)(null),
    _useState44 = _slicedToArray(_useState43, 2),
    removeRoverBoxStatus = _useState44[0],
    setRemoveRoverBoxStatus = _useState44[1];
  var _useState45 = (0, _react.useState)(null),
    _useState46 = _slicedToArray(_useState45, 2),
    addRoverBoxStatus = _useState46[0],
    setAddRoverBoxStatus = _useState46[1];
  var _useState47 = (0, _react.useState)(null),
    _useState48 = _slicedToArray(_useState47, 2),
    labBox = _useState48[0],
    setLabBox = _useState48[1];
  var _useState49 = (0, _react.useState)(false),
    _useState50 = _slicedToArray(_useState49, 2),
    changeLabBox = _useState50[0],
    setChangeLabBox = _useState50[1];
  var _useState51 = (0, _react.useState)(0),
    _useState52 = _slicedToArray(_useState51, 2),
    selectedLabBox = _useState52[0],
    setSelectedLabBox = _useState52[1];
  var _useState53 = (0, _react.useState)([]),
    _useState54 = _slicedToArray(_useState53, 2),
    labBoxes = _useState54[0],
    setLabBoxes = _useState54[1];
  var _useState55 = (0, _react.useState)(null),
    _useState56 = _slicedToArray(_useState55, 2),
    removeLabBoxStatus = _useState56[0],
    setRemoveLabBoxStatus = _useState56[1];
  var _useState57 = (0, _react.useState)(null),
    _useState58 = _slicedToArray(_useState57, 2),
    addLabBoxStatus = _useState58[0],
    setAddLabBoxStatus = _useState58[1];
  var _useState59 = (0, _react.useState)(null),
    _useState60 = _slicedToArray(_useState59, 2),
    stickBox = _useState60[0],
    setStickBox = _useState60[1];
  var _useState61 = (0, _react.useState)(false),
    _useState62 = _slicedToArray(_useState61, 2),
    changeStickBox = _useState62[0],
    setChangeStickBox = _useState62[1];
  var _useState63 = (0, _react.useState)(0),
    _useState64 = _slicedToArray(_useState63, 2),
    selectedStickBox = _useState64[0],
    setSelectedStickBox = _useState64[1];
  var _useState65 = (0, _react.useState)([]),
    _useState66 = _slicedToArray(_useState65, 2),
    stickBoxes = _useState66[0],
    setStickBoxes = _useState66[1];
  var _useState67 = (0, _react.useState)(null),
    _useState68 = _slicedToArray(_useState67, 2),
    removeStickBoxStatus = _useState68[0],
    setRemoveStickBoxStatus = _useState68[1];
  var _useState69 = (0, _react.useState)(null),
    _useState70 = _slicedToArray(_useState69, 2),
    addStickBoxStatus = _useState70[0],
    setAddStickBoxStatus = _useState70[1];
  var _useState71 = (0, _react.useState)(false),
    _useState72 = _slicedToArray(_useState71, 2),
    changePtu1 = _useState72[0],
    setChangePtu1 = _useState72[1];
  var _useState73 = (0, _react.useState)(false),
    _useState74 = _slicedToArray(_useState73, 2),
    changePtu2 = _useState74[0],
    setChangePtu2 = _useState74[1];
  var _useState75 = (0, _react.useState)(false),
    _useState76 = _slicedToArray(_useState75, 2),
    changePtu3 = _useState76[0],
    setChangePtu3 = _useState76[1];
  var _useState77 = (0, _react.useState)(false),
    _useState78 = _slicedToArray(_useState77, 2),
    changePtu4 = _useState78[0],
    setChangePtu4 = _useState78[1];
  var _useState79 = (0, _react.useState)(0),
    _useState80 = _slicedToArray(_useState79, 2),
    selectedPtu = _useState80[0],
    setSelectedPtu = _useState80[1];
  var _useState81 = (0, _react.useState)(null),
    _useState82 = _slicedToArray(_useState81, 2),
    oldPtu = _useState82[0],
    setOldPtu = _useState82[1];
  var _useState83 = (0, _react.useState)([]),
    _useState84 = _slicedToArray(_useState83, 2),
    availablePtus = _useState84[0],
    setAvailablePtus = _useState84[1];
  var _useState85 = (0, _react.useState)(null),
    _useState86 = _slicedToArray(_useState85, 2),
    removePtuStatus = _useState86[0],
    setRemovePtuStatus = _useState86[1];
  var _useState87 = (0, _react.useState)(null),
    _useState88 = _slicedToArray(_useState87, 2),
    addPtuStatus = _useState88[0],
    setAddPtuStatus = _useState88[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function retrieveDataBoxitunnel() {
    return _retrieveDataBoxitunnel.apply(this, arguments);
  }
  function _retrieveDataBoxitunnel() {
    _retrieveDataBoxitunnel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, resCpuBox, dataCpuBox, resPowerBox, dataPowerBox, resTunnelBox, dataTunnelBox;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Retrieve (cpuBox, powerBox)/(tunnelBox) linked to equipment 
            if (!((equipment['version'].startsWith('1') || equipment['version'].startsWith('2')) && !equipment['version'].startsWith('2.1'))) {
              _context.n = 5;
              break;
            }
            _context.n = 1;
            return fetch(path + "/api/eq-cpbo/?equipment_id=" + equipment['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 1:
            resCpuBox = _context.v;
            _context.n = 2;
            return resCpuBox.json();
          case 2:
            dataCpuBox = _context.v;
            setCpuBox(dataCpuBox["results"][0]);
            // Retrieve powerBox
            _context.n = 3;
            return fetch(path + "/api/eq-pobo/?equipment_id=" + equipment['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 3:
            resPowerBox = _context.v;
            _context.n = 4;
            return resPowerBox.json();
          case 4:
            dataPowerBox = _context.v;
            setPowerBox(dataPowerBox["results"][0]);
            _context.n = 8;
            break;
          case 5:
            _context.n = 6;
            return fetch(path + "/api/eq-tubo/?equipment_id=" + equipment['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 6:
            resTunnelBox = _context.v;
            _context.n = 7;
            return resTunnelBox.json();
          case 7:
            dataTunnelBox = _context.v;
            setTunnelBox(dataTunnelBox["results"][0]);
          case 8:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveDataBoxitunnel.apply(this, arguments);
  }
  function retrieveDataBoxirover() {
    return _retrieveDataBoxirover.apply(this, arguments);
  }
  function _retrieveDataBoxirover() {
    _retrieveDataBoxirover = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, resRoverBox, dataRoverBox;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve roverBox linked to equipment if product name = Boxirover
            _context2.n = 1;
            return fetch(path + "/api/eq-robo/?equipment_id=" + equipment['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resRoverBox = _context2.v;
            _context2.n = 2;
            return resRoverBox.json();
          case 2:
            dataRoverBox = _context2.v;
            setRoverBox(dataRoverBox["results"][0]);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _retrieveDataBoxirover.apply(this, arguments);
  }
  function retrieveDataBoxilab() {
    return _retrieveDataBoxilab.apply(this, arguments);
  }
  function _retrieveDataBoxilab() {
    _retrieveDataBoxilab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var token, resLabBox, dataLabBox;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve labBox linked to equipment if product name = BoxiLab
            _context3.n = 1;
            return fetch(path + "/api/eq-labo/?equipment_id=" + equipment['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resLabBox = _context3.v;
            _context3.n = 2;
            return resLabBox.json();
          case 2:
            dataLabBox = _context3.v;
            setLabBox(dataLabBox["results"][0]);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _retrieveDataBoxilab.apply(this, arguments);
  }
  function retrieveDataBoxistick() {
    return _retrieveDataBoxistick.apply(this, arguments);
  }
  function _retrieveDataBoxistick() {
    _retrieveDataBoxistick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var token, resStickBox, dataStickBox;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve stickBox linked to equipment if product name = Boxistick
            _context4.n = 1;
            return fetch(path + "/api/eq-stbo/?equipment_id=" + equipment['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resStickBox = _context4.v;
            _context4.n = 2;
            return resStickBox.json();
          case 2:
            dataStickBox = _context4.v;
            setStickBox(dataStickBox["results"][0]);
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _retrieveDataBoxistick.apply(this, arguments);
  }
  function retrievePtus() {
    return _retrievePtus.apply(this, arguments);
  }
  function _retrievePtus() {
    _retrievePtus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            setReload(true);
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return _retrievePtus.apply(this, arguments);
  }
  function retrieveCpuBoxes() {
    return _retrieveCpuBoxes.apply(this, arguments);
  }
  function _retrieveCpuBoxes() {
    _retrieveCpuBoxes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var token, resCpuBox, dataCpuBox;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve cpuBoxes disponibles
            _context6.n = 1;
            return fetch(path + "/api/eq-cpbo/?equipment_id=0", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resCpuBox = _context6.v;
            _context6.n = 2;
            return resCpuBox.json();
          case 2:
            dataCpuBox = _context6.v;
            setCpuBoxes(dataCpuBox["results"]);
          case 3:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return _retrieveCpuBoxes.apply(this, arguments);
  }
  function retrievePowerBoxes() {
    return _retrievePowerBoxes.apply(this, arguments);
  }
  function _retrievePowerBoxes() {
    _retrievePowerBoxes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var token, resPowerBox, dataPowerBox;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve powerBoxes disponibles
            _context7.n = 1;
            return fetch(path + "/api/eq-pobo/?equipment_id=0", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resPowerBox = _context7.v;
            _context7.n = 2;
            return resPowerBox.json();
          case 2:
            dataPowerBox = _context7.v;
            setPowerBoxes(dataPowerBox["results"]);
          case 3:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return _retrievePowerBoxes.apply(this, arguments);
  }
  function retrieveTunnelBoxes() {
    return _retrieveTunnelBoxes.apply(this, arguments);
  }
  function _retrieveTunnelBoxes() {
    _retrieveTunnelBoxes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var token, resTunnelBox, dataTunnelBox;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve tunnelBoxes disponibles
            _context8.n = 1;
            return fetch(path + "/api/eq-tubo/?equipment_id=0", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resTunnelBox = _context8.v;
            _context8.n = 2;
            return resTunnelBox.json();
          case 2:
            dataTunnelBox = _context8.v;
            setTunnelBoxes(dataTunnelBox["results"]);
          case 3:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return _retrieveTunnelBoxes.apply(this, arguments);
  }
  function retrieveRoverBoxes() {
    return _retrieveRoverBoxes.apply(this, arguments);
  }
  function _retrieveRoverBoxes() {
    _retrieveRoverBoxes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var token, resRoverBox, dataRoverBox;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve roverBoxes disponibles
            _context9.n = 1;
            return fetch(path + "/api/eq-robo/?equipment_id=0", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resRoverBox = _context9.v;
            _context9.n = 2;
            return resRoverBox.json();
          case 2:
            dataRoverBox = _context9.v;
            setRoverBoxes(dataRoverBox["results"]);
          case 3:
            return _context9.a(2);
        }
      }, _callee9);
    }));
    return _retrieveRoverBoxes.apply(this, arguments);
  }
  function retrieveLabBoxes() {
    return _retrieveLabBoxes.apply(this, arguments);
  }
  function _retrieveLabBoxes() {
    _retrieveLabBoxes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
      var token, resLabBox, dataLabBox;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve labBoxes disponibles
            _context0.n = 1;
            return fetch(path + "/api/eq-labo/?equipment_id=0", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resLabBox = _context0.v;
            _context0.n = 2;
            return resLabBox.json();
          case 2:
            dataLabBox = _context0.v;
            setLabBoxes(dataLabBox["results"]);
          case 3:
            return _context0.a(2);
        }
      }, _callee0);
    }));
    return _retrieveLabBoxes.apply(this, arguments);
  }
  function retrieveStickBoxes() {
    return _retrieveStickBoxes.apply(this, arguments);
  }
  function _retrieveStickBoxes() {
    _retrieveStickBoxes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
      var token, resStickBox, dataStickBox;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve stickBoxes disponibles
            _context1.n = 1;
            return fetch(path + "/api/eq-stbo/?equipment_id=0", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resStickBox = _context1.v;
            _context1.n = 2;
            return resStickBox.json();
          case 2:
            dataStickBox = _context1.v;
            setStickBoxes(dataStickBox["results"]);
          case 3:
            return _context1.a(2);
        }
      }, _callee1);
    }));
    return _retrieveStickBoxes.apply(this, arguments);
  }
  function retrieveAvailablePtus() {
    return _retrieveAvailablePtus.apply(this, arguments);
  }
  function _retrieveAvailablePtus() {
    _retrieveAvailablePtus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
      var token, resPtu, dataPtu;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve stickBoxes disponibles
            _context10.n = 1;
            return fetch(path + "/api/eq-mole/?equipment_id=0&product_id=" + equipment['product']['id'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resPtu = _context10.v;
            _context10.n = 2;
            return resPtu.json();
          case 2:
            dataPtu = _context10.v;
            setAvailablePtus(dataPtu["results"]);
          case 3:
            return _context10.a(2);
        }
      }, _callee10);
    }));
    return _retrieveAvailablePtus.apply(this, arguments);
  }
  var activeChangeCPUBox = function activeChangeCPUBox(event, bool) {
    event.preventDefault();
    if (bool === true) {
      retrieveCpuBoxes();
    }
    setChangeCpuBox(bool);
  };
  var activeChangePowerBox = function activeChangePowerBox(event, bool) {
    event.preventDefault();
    if (bool === true) {
      retrievePowerBoxes();
    }
    setChangePowerBox(bool);
  };
  var activeChangeTunnelBox = function activeChangeTunnelBox(event, bool) {
    event.preventDefault();
    if (bool === true) {
      retrieveTunnelBoxes();
    }
    setChangeTunnelBox(bool);
  };
  var activeChangeRoverBox = function activeChangeRoverBox(event, bool) {
    event.preventDefault();
    if (bool === true) {
      retrieveRoverBoxes();
    }
    setChangeRoverBox(bool);
  };
  var activeChangeLabBox = function activeChangeLabBox(event, bool) {
    event.preventDefault();
    if (bool === true) {
      retrieveLabBoxes();
    }
    setChangeLabBox(bool);
  };
  var activeChangeStickBox = function activeChangeStickBox(event, bool) {
    event.preventDefault();
    if (bool === true) {
      retrieveStickBoxes();
    }
    setChangeStickBox(bool);
  };
  var activeChangePtu = function activeChangePtu(event, bool, index) {
    event.preventDefault();
    if (bool === true) {
      retrieveAvailablePtus();
      if (ptus.length === 0) {
        setOldPtu(ptus[index]);
      }
    }
    if (index + 1 === 1) {
      setChangePtu1(bool);
    } else if (index + 1 === 2) {
      setChangePtu2(bool);
    } else if (index + 1 === 3) {
      setChangePtu3(bool);
    } else if (index + 1 === 4) {
      setChangePtu4(bool);
    }
  };
  function changePtuValue(index) {
    if (index + 1 === 1) {
      return changePtu1;
    } else if (index + 1 === 2) {
      return changePtu2;
    } else if (index + 1 === 3) {
      return changePtu3;
    } else if (index + 1 === 4) {
      return changePtu4;
    } else {
      return false;
    }
  }
  ;
  function removeCpuBox() {
    return _removeCpuBox.apply(this, arguments);
  }
  function _removeCpuBox() {
    _removeCpuBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien CpuBox de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context11.n = 1;
            return fetch(path + "/api/eq-cpbo/" + cpuBox['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context11.v;
            setRemoveCpuBoxStatus(response['status']);
          case 2:
            return _context11.a(2);
        }
      }, _callee11);
    }));
    return _removeCpuBox.apply(this, arguments);
  }
  function addCpuBox() {
    return _addCpuBox.apply(this, arguments);
  }
  function _addCpuBox() {
    _addCpuBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau CpuBox à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            _context12.n = 1;
            return fetch(path + "/api/eq-cpbo/" + selectedCpuBox + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context12.v;
            setAddCpuBoxStatus(response['status']);
          case 2:
            return _context12.a(2);
        }
      }, _callee12);
    }));
    return _addCpuBox.apply(this, arguments);
  }
  function removePowerBox() {
    return _removePowerBox.apply(this, arguments);
  }
  function _removePowerBox() {
    _removePowerBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien powerBox de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context13.n = 1;
            return fetch(path + "/api/eq-pobo/" + powerBox['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context13.v;
            setRemovePowerBoxStatus(response['status']);
          case 2:
            return _context13.a(2);
        }
      }, _callee13);
    }));
    return _removePowerBox.apply(this, arguments);
  }
  function addPowerBox() {
    return _addPowerBox.apply(this, arguments);
  }
  function _addPowerBox() {
    _addPowerBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau powerBox à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            _context14.n = 1;
            return fetch(path + "/api/eq-pobo/" + selectedPowerBox + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context14.v;
            setAddPowerBoxStatus(response['status']);
          case 2:
            return _context14.a(2);
        }
      }, _callee14);
    }));
    return _addPowerBox.apply(this, arguments);
  }
  function removeTunnelBox() {
    return _removeTunnelBox.apply(this, arguments);
  }
  function _removeTunnelBox() {
    _removeTunnelBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien tunnelBox de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context15.n = 1;
            return fetch(path + "/api/eq-tubo/" + tunnelBox['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context15.v;
            setRemoveTunnelBoxStatus(response['status']);
          case 2:
            return _context15.a(2);
        }
      }, _callee15);
    }));
    return _removeTunnelBox.apply(this, arguments);
  }
  function addTunnelBox() {
    return _addTunnelBox.apply(this, arguments);
  }
  function _addTunnelBox() {
    _addTunnelBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau tunnelBox à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            _context16.n = 1;
            return fetch(path + "/api/eq-tubo/" + selectedTunnelBox + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context16.v;
            setAddTunnelBoxStatus(response['status']);
          case 2:
            return _context16.a(2);
        }
      }, _callee16);
    }));
    return _addTunnelBox.apply(this, arguments);
  }
  function removeRoverBox() {
    return _removeRoverBox.apply(this, arguments);
  }
  function _removeRoverBox() {
    _removeRoverBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context17) {
        while (1) switch (_context17.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien roverBox de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context17.n = 1;
            return fetch(path + "/api/eq-robo/" + roverBox['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context17.v;
            setRemoveRoverBoxStatus(response['status']);
          case 2:
            return _context17.a(2);
        }
      }, _callee17);
    }));
    return _removeRoverBox.apply(this, arguments);
  }
  function addRoverBox() {
    return _addRoverBox.apply(this, arguments);
  }
  function _addRoverBox() {
    _addRoverBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau roverBox à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            _context18.n = 1;
            return fetch(path + "/api/eq-robo/" + selectedRoverBox + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context18.v;
            setAddRoverBoxStatus(response['status']);
          case 2:
            return _context18.a(2);
        }
      }, _callee18);
    }));
    return _addRoverBox.apply(this, arguments);
  }
  function removeLabBox() {
    return _removeLabBox.apply(this, arguments);
  }
  function _removeLabBox() {
    _removeLabBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien labBox de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context19.n = 1;
            return fetch(path + "/api/eq-labo/" + labBox['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context19.v;
            setRemoveLabBoxStatus(response['status']);
          case 2:
            return _context19.a(2);
        }
      }, _callee19);
    }));
    return _removeLabBox.apply(this, arguments);
  }
  function addLabBox() {
    return _addLabBox.apply(this, arguments);
  }
  function _addLabBox() {
    _addLabBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau labBox à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            _context20.n = 1;
            return fetch(path + "/api/eq-labo/" + selectedLabBox + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context20.v;
            setAddLabBoxStatus(response['status']);
          case 2:
            return _context20.a(2);
        }
      }, _callee20);
    }));
    return _addLabBox.apply(this, arguments);
  }
  function removeStickBox() {
    return _removeStickBox.apply(this, arguments);
  }
  function _removeStickBox() {
    _removeStickBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien stickBox de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context21.n = 1;
            return fetch(path + "/api/eq-stbo/" + stickBox['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context21.v;
            setRemoveStickBoxStatus(response['status']);
          case 2:
            return _context21.a(2);
        }
      }, _callee21);
    }));
    return _removeStickBox.apply(this, arguments);
  }
  function addStickBox() {
    return _addStickBox.apply(this, arguments);
  }
  function _addStickBox() {
    _addStickBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau stickBox à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            _context22.n = 1;
            return fetch(path + "/api/eq-stbo/" + selectedStickBox + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context22.v;
            setAddStickBoxStatus(response['status']);
          case 2:
            return _context22.a(2);
        }
      }, _callee22);
    }));
    return _addStickBox.apply(this, arguments);
  }
  function removePtu() {
    return _removePtu.apply(this, arguments);
  }
  function _removePtu() {
    _removePtu = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
      var token, form_data_old, response;
      return _regenerator().w(function (_context23) {
        while (1) switch (_context23.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Suppression de l'ancien Ptu de l'équipemnt
            form_data_old = new FormData();
            form_data_old.append("new_equipment_id", null);
            _context23.n = 1;
            return fetch(path + "/api/eq-mole/" + oldPtu['id'] + "/remove-equipment/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_old
            });
          case 1:
            response = _context23.v;
            setRemovePtuStatus(response['status']);
          case 2:
            return _context23.a(2);
        }
      }, _callee23);
    }));
    return _removePtu.apply(this, arguments);
  }
  function addPtu() {
    return _addPtu.apply(this, arguments);
  } // Define useEffect hooks
  function _addPtu() {
    _addPtu = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
      var token, form_data_new, response;
      return _regenerator().w(function (_context24) {
        while (1) switch (_context24.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Ajout du nouveau Ptu à l'équipemnt
            form_data_new = new FormData();
            form_data_new.append("equipment_id", equipment['id']);
            if (oldPtu === null || oldPtu === undefined) {
              form_data_new.append("port", 1);
            } else {
              form_data_new.append("port", oldPtu['port']);
            }
            _context24.n = 1;
            return fetch(path + "/api/eq-mole/" + selectedPtu + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data_new
            });
          case 1:
            response = _context24.v;
            setAddPtuStatus(response['status']);
          case 2:
            return _context24.a(2);
        }
      }, _callee24);
    }));
    return _addPtu.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      if (equipment['product']['name'] === 'Boxitunnel') {
        retrieveDataBoxitunnel();
      } else if (equipment['product']['name'] === 'BoxiLab') {
        retrieveDataBoxilab();
      } else if (equipment['product']['name'] === 'Boxistick') {
        retrieveDataBoxistick();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (cpuBox !== null && cpuBox !== undefined) {
      if (Number(selectedCpuBox) > 0) {
        removeCpuBox();
      }
    } else {
      setRemoveCpuBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCpuBox]);
  (0, _react.useEffect)(function () {
    if (removeCpuBoxStatus === 200 && Number(selectedCpuBox) > 0) {
      addCpuBox();
    } else {
      setAddCpuBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeCpuBoxStatus]);
  (0, _react.useEffect)(function () {
    if (addCpuBoxStatus === 200) {
      retrieveDataBoxitunnel();
      setChangeCpuBox(false);
      setSelectedCpuBox(0);
      setRemoveCpuBoxStatus(null);
      setAddCpuBoxStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCpuBoxStatus]);
  (0, _react.useEffect)(function () {
    if (powerBox !== null && powerBox !== undefined) {
      if (Number(selectedPowerBox) > 0) {
        removePowerBox();
      }
    } else {
      setRemovePowerBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPowerBox]);
  (0, _react.useEffect)(function () {
    if (removePowerBoxStatus === 200 && Number(selectedPowerBox) > 0) {
      addPowerBox();
    } else {
      setAddPowerBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removePowerBoxStatus]);
  (0, _react.useEffect)(function () {
    if (addPowerBoxStatus === 200) {
      retrieveDataBoxitunnel();
      setChangePowerBox(false);
      setSelectedPowerBox(0);
      setRemovePowerBoxStatus(null);
      setAddPowerBoxStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addPowerBoxStatus]);
  (0, _react.useEffect)(function () {
    if (tunnelBox !== null && tunnelBox !== undefined) {
      if (Number(selectedTunnelBox) > 0) {
        removeTunnelBox();
      }
    } else {
      setRemoveTunnelBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTunnelBox]);
  (0, _react.useEffect)(function () {
    if (removeTunnelBoxStatus === 200 && Number(selectedTunnelBox) > 0) {
      addTunnelBox();
    } else {
      setAddTunnelBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeTunnelBoxStatus]);
  (0, _react.useEffect)(function () {
    if (addTunnelBoxStatus === 200) {
      retrieveDataBoxitunnel();
      setChangeTunnelBox(false);
      setSelectedTunnelBox(0);
      setRemoveTunnelBoxStatus(null);
      setAddTunnelBoxStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addTunnelBoxStatus]);
  (0, _react.useEffect)(function () {
    if (roverBox !== null && roverBox !== undefined) {
      if (Number(selectedRoverBox) > 0) {
        removeRoverBox();
      }
    } else {
      setRemoveRoverBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRoverBox]);
  (0, _react.useEffect)(function () {
    if (removeRoverBoxStatus === 200 && Number(selectedRoverBox) > 0) {
      addRoverBox();
    } else {
      setAddRoverBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeRoverBoxStatus]);
  (0, _react.useEffect)(function () {
    if (addRoverBoxStatus === 200) {
      retrieveDataBoxirover();
      setChangeRoverBox(false);
      setSelectedRoverBox(0);
      setRemoveRoverBoxStatus(null);
      setAddRoverBoxStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addRoverBoxStatus]);
  (0, _react.useEffect)(function () {
    if (labBox !== null && labBox !== undefined) {
      if (Number(selectedLabBox) > 0) {
        removeLabBox();
      }
    } else {
      setRemoveLabBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLabBox]);
  (0, _react.useEffect)(function () {
    if (removeLabBoxStatus === 200 && Number(selectedLabBox) > 0) {
      addLabBox();
    } else {
      setAddLabBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeLabBoxStatus]);
  (0, _react.useEffect)(function () {
    if (addLabBoxStatus === 200) {
      retrieveDataBoxilab();
      setChangeLabBox(false);
      setSelectedLabBox(0);
      setRemoveLabBoxStatus(null);
      setAddLabBoxStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addLabBoxStatus]);
  (0, _react.useEffect)(function () {
    if (stickBox !== null && stickBox !== undefined) {
      if (Number(selectedStickBox) > 0) {
        removeStickBox();
      }
    } else {
      setRemoveStickBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStickBox]);
  (0, _react.useEffect)(function () {
    if (removeStickBoxStatus === 200 && Number(selectedStickBox) > 0) {
      addStickBox();
    } else {
      setAddStickBoxStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeStickBoxStatus]);
  (0, _react.useEffect)(function () {
    if (addStickBoxStatus === 200) {
      retrieveDataBoxistick();
      setChangeStickBox(false);
      setSelectedStickBox(0);
      setRemoveStickBoxStatus(null);
      setAddStickBoxStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addStickBoxStatus]);
  (0, _react.useEffect)(function () {
    if (oldPtu !== null && oldPtu !== undefined) {
      if (Number(selectedPtu) > 0) {
        removePtu();
      }
    } else {
      setRemovePtuStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPtu]);
  (0, _react.useEffect)(function () {
    if (removePtuStatus === 200 && Number(selectedPtu) > 0) {
      addPtu();
    } else {
      setAddPtuStatus(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removePtuStatus]);
  (0, _react.useEffect)(function () {
    if (addPtuStatus === 200) {
      retrievePtus();
      setChangePtu1(false);
      setChangePtu2(false);
      setChangePtu3(false);
      setChangePtu4(false);
      setSelectedPtu(0);
      setRemovePtuStatus(null);
      setAddPtuStatus(null);
      setOldPtu(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addPtuStatus]);

  // Render component
  if (equipment['product']['name'] === 'Boxitunnel') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
      component: _Paper["default"],
      className: "margin-bottom margin-top table-border",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table2["default"], {
        sx: {
          minWidth: 300
        },
        size: "small",
        "aria-label": "a dense table",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: " "
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Serial number"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Version"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Port"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Fan_option"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Nombre d'alim"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label"
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableBody["default"], {
          children: [(equipment['version'].startsWith('1') || equipment['version'].startsWith('2')) && !equipment['version'].startsWith('2.1') ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "Boitier CPU"
            }), cpuBox !== null && cpuBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: cpuBox['serial_number']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), cpuBox !== null && cpuBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: cpuBox['version']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changeCpuBox === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangeCPUBox(e, true);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedCpuBox,
                onChange: function onChange(e) {
                  return setSelectedCpuBox(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangeCPUBox(e, false);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), cpuBoxes.map(function (cpuBox) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: cpuBox['id'],
                    children: [cpuBox['serial_number'], " - version ", cpuBox['version']]
                  }, cpuBox['id']);
                })]
              })
            })]
          }) : null, (equipment['version'].startsWith('1') || equipment['version'].startsWith('2')) && !equipment['version'].startsWith('2.1') ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "Boitier distribution"
            }), powerBox !== null && powerBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: powerBox['serial_number']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), powerBox !== null && powerBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: powerBox['version']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), powerBox !== null && powerBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: powerBox['number_power_supply']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changePowerBox === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangePowerBox(e, true);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedPowerBox,
                onChange: function onChange(e) {
                  return setSelectedPowerBox(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangePowerBox(e, false);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), powerBoxes.map(function (powerBox) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: powerBox['id'],
                    children: [powerBox['serial_number'], " - version ", powerBox['version']]
                  }, powerBox['id']);
                })]
              })
            })]
          }) : null, (equipment['version'].startsWith('1') || equipment['version'].startsWith('2')) && !equipment['version'].startsWith('2.1') ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "Boitier Boxitunnel"
            }), tunnelBox !== null && tunnelBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: tunnelBox['serial_number']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), tunnelBox !== null && tunnelBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: tunnelBox['version']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), tunnelBox !== null && tunnelBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: tunnelBox['number_power_supply']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changeTunnelBox === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangeTunnelBox(e, true);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedTunnelBox,
                onChange: function onChange(e) {
                  return setSelectedTunnelBox(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangeTunnelBox(e, false);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), tunnelBoxes.map(function (tunnelBox) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: tunnelBox['id'],
                    children: [tunnelBox['serial_number'], " - version ", tunnelBox['version']]
                  }, tunnelBox['id']);
                })]
              })
            })]
          }), ptus && ptus.length !== 0 ? ptus.sort(function (a, b) {
            return a.port > b.port ? 1 : -1;
          }).map(function (ptu, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: ["PTU ", ptu['port']]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['serial_number']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['version']
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                children: ["0x0", ptu['port'].toString(16)]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconActivation["default"], {
                  input: ptu['fan_option']
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: " "
              }), changePtuValue(index) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.EditIcon,
                  alt: "edit_item_icon",
                  onClick: function onClick(e) {
                    return activeChangePtu(e, true, index);
                  },
                  className: "link-img link-icon"
                })
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                  name: "selectedChoice",
                  className: "select-form-option",
                  value: selectedPtu,
                  onChange: function onChange(e) {
                    return setSelectedPtu(e.target.value);
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                    onClick: function onClick(e) {
                      return activeChangePtu(e, false, index);
                    },
                    value: 0,
                    children: '--Annuler--'
                  }), availablePtus.map(function (availablePtu) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                      value: availablePtu['id'],
                      children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                    }, availablePtu['id']);
                  })]
                })
              })]
            }, ptu.id);
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "PTU"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changePtuValue(false) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangePtu(e, true, 0);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedPtu,
                onChange: function onChange(e) {
                  return setSelectedPtu(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangePtu(e, false, 0);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), availablePtus.map(function (availablePtu) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: availablePtu['id'],
                    children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                  }, availablePtu['id']);
                })]
              })
            })]
          })]
        })]
      })
    });
  } else if (equipment['product']['name'] === 'Boxirover') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
      component: _Paper["default"],
      className: "margin-bottom margin-top  table-border",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table2["default"], {
        sx: {
          minWidth: 300
        },
        size: "small",
        "aria-label": "a dense table",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: " "
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Serial number"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Version"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Port"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Fan_option"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Nombre d'alim"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label"
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableBody["default"], {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "Boitier Boxirover"
            }), roverBox !== null && roverBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: roverBox['serial_number']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), roverBox !== null && roverBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: roverBox['version']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changeRoverBox === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangeRoverBox(e, true);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedRoverBox,
                onChange: function onChange(e) {
                  return setSelectedRoverBox(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangeRoverBox(e, false);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), roverBoxes.map(function (roverBox) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: roverBox['id'],
                    children: [roverBox['serial_number'], " - version ", roverBox['version']]
                  }, roverBox['id']);
                })]
              })
            })]
          }), ptus && ptus.length !== 0 ? ptus.sort(function (a, b) {
            return a.port > b.port ? 1 : -1;
          }).map(function (ptu, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: ["PTU ", ptu['port']]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['serial_number']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['version']
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                children: ["0x0", ptu['port'].toString(16)]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconActivation["default"], {
                  input: ptu['fan_option']
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: " "
              }), changePtuValue(index) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.EditIcon,
                  alt: "edit_item_icon",
                  onClick: function onClick(e) {
                    return activeChangePtu(e, true, index);
                  },
                  className: "link-img link-icon"
                })
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                  name: "selectedChoice",
                  className: "select-form-option",
                  value: selectedPtu,
                  onChange: function onChange(e) {
                    return setSelectedPtu(e.target.value);
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                    onClick: function onClick(e) {
                      return activeChangePtu(e, false, index);
                    },
                    value: 0,
                    children: '--Annuler--'
                  }), availablePtus.map(function (availablePtu) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                      value: availablePtu['id'],
                      children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                    }, availablePtu['id']);
                  })]
                })
              })]
            }, ptu.id);
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "PTU"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changePtuValue(false) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangePtu(e, true, 0);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedPtu,
                onChange: function onChange(e) {
                  return setSelectedPtu(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangePtu(e, false, 0);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), availablePtus.map(function (availablePtu) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: availablePtu['id'],
                    children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                  }, availablePtu['id']);
                })]
              })
            })]
          })]
        })]
      })
    });
  } else if (equipment['product']['name'] === 'BoxiLab') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
      component: _Paper["default"],
      className: "margin-bottom margin-top  table-border",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table2["default"], {
        sx: {
          minWidth: 300
        },
        size: "small",
        "aria-label": "a dense table",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: " "
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Serial number"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Version"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label"
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableBody["default"], {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "Boitier Boxilab"
            }), labBox !== null && labBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: labBox['serial_number']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), labBox !== null && labBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: labBox['version']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changeLabBox === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangeLabBox(e, true);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedLabBox,
                onChange: function onChange(e) {
                  return setSelectedLabBox(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangeLabBox(e, false);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), labBoxes.map(function (labBox) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: labBox['id'],
                    children: [labBox['serial_number'], " - version ", labBox['version']]
                  }, labBox['id']);
                })]
              })
            })]
          }), ptus && ptus.length !== 0 ? ptus.sort(function (a, b) {
            return a.port > b.port ? 1 : -1;
          }).map(function (ptu, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: ["PTU ", ptu['port']]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['serial_number']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['version']
              }), changePtuValue(index) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.EditIcon,
                  alt: "edit_item_icon",
                  onClick: function onClick(e) {
                    return activeChangePtu(e, true, index);
                  },
                  className: "link-img link-icon"
                })
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                  name: "selectedChoice",
                  className: "select-form-option",
                  value: selectedPtu,
                  onChange: function onChange(e) {
                    return setSelectedPtu(e.target.value);
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                    onClick: function onClick(e) {
                      return activeChangePtu(e, false, index);
                    },
                    value: 0,
                    children: '--Annuler--'
                  }), availablePtus.map(function (availablePtu) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                      value: availablePtu['id'],
                      children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                    }, availablePtu['id']);
                  })]
                })
              })]
            }, ptu.id);
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "PTU"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changePtuValue(false) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangePtu(e, true, 0);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedPtu,
                onChange: function onChange(e) {
                  return setSelectedPtu(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangePtu(e, false, 0);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), availablePtus.map(function (availablePtu) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: availablePtu['id'],
                    children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                  }, availablePtu['id']);
                })]
              })
            })]
          })]
        })]
      })
    });
  } else if (equipment['product']['name'] === 'Boxistick') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
      component: _Paper["default"],
      className: "margin-bottom margin-top table-border",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table2["default"], {
        sx: {
          minWidth: 300
        },
        size: "small",
        "aria-label": "a dense table",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: " "
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Serial number"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Version"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label"
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableBody["default"], {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "Boitier Boxistick"
            }), stickBox !== null && stickBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: stickBox['serial_number']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), stickBox !== null && stickBox !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: stickBox['version']
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changeStickBox === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangeStickBox(e, true);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedStickBox,
                onChange: function onChange(e) {
                  return setSelectedStickBox(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangeStickBox(e, false);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), stickBoxes.map(function (stickBox) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: stickBox['id'],
                    children: [stickBox['serial_number'], " - version ", stickBox['version']]
                  }, stickBox['id']);
                })]
              })
            })]
          }), ptus && ptus.length !== 0 ? ptus.sort(function (a, b) {
            return a.port > b.port ? 1 : -1;
          }).map(function (ptu, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: ["PTU ", ptu['port']]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['serial_number']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['version']
              }), changePtuValue(index) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.EditIcon,
                  alt: "edit_item_icon",
                  onClick: function onClick(e) {
                    return activeChangePtu(e, true, index);
                  },
                  className: "link-img link-icon"
                })
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                  name: "selectedChoice",
                  className: "select-form-option",
                  value: selectedPtu,
                  onChange: function onChange(e) {
                    return setSelectedPtu(e.target.value);
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                    onClick: function onClick(e) {
                      return activeChangePtu(e, false, index);
                    },
                    value: 0,
                    children: '--Annuler--'
                  }), availablePtus.map(function (availablePtu) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                      value: availablePtu['id'],
                      children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                    }, availablePtu['id']);
                  })]
                })
              })]
            }, ptu.id);
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "PTU"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changePtuValue(false) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangePtu(e, true, 0);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedPtu,
                onChange: function onChange(e) {
                  return setSelectedPtu(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangePtu(e, false, 0);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), availablePtus.map(function (availablePtu) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: availablePtu['id'],
                    children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                  }, availablePtu['id']);
                })]
              })
            })]
          })]
        })]
      })
    });
  } else if (equipment['product']['name'] === 'Boxiclean') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
      component: _Paper["default"],
      className: "margin-bottom margin-top table-border",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table2["default"], {
        sx: {
          minWidth: 300
        },
        size: "small",
        "aria-label": "a dense table",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: " "
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Serial number"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Version"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label"
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
          children: ptus && ptus.length !== 0 ? ptus.sort(function (a, b) {
            return a.port > b.port ? 1 : -1;
          }).map(function (ptu, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: ["PTU ", ptu['port']]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['serial_number']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: ptu['version']
              }), changePtuValue(index) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.EditIcon,
                  alt: "edit_item_icon",
                  onClick: function onClick(e) {
                    return activeChangePtu(e, true, index);
                  },
                  className: "link-img link-icon"
                })
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                  name: "selectedChoice",
                  className: "select-form-option",
                  value: selectedPtu,
                  onChange: function onChange(e) {
                    return setSelectedPtu(e.target.value);
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                    onClick: function onClick(e) {
                      return activeChangePtu(e, false, index);
                    },
                    value: 0,
                    children: '--Annuler--'
                  }), availablePtus.map(function (availablePtu) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                      value: availablePtu['id'],
                      children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                    }, availablePtu['id']);
                  })]
                })
              })]
            }, ptu.id);
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: "PTU"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: "Non attribu\xE9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: " "
            }), changePtuValue(false) === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _dist.EditIcon,
                alt: "edit_item_icon",
                onClick: function onClick(e) {
                  return activeChangePtu(e, true, 0);
                },
                className: "link-img link-icon"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                name: "selectedChoice",
                className: "select-form-option",
                value: selectedPtu,
                onChange: function onChange(e) {
                  return setSelectedPtu(e.target.value);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  onClick: function onClick(e) {
                    return activeChangePtu(e, false, 0);
                  },
                  value: 0,
                  children: '--Annuler--'
                }), availablePtus.map(function (availablePtu) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                    value: availablePtu['id'],
                    children: [availablePtu['serial_number'], " - version ", availablePtu['version']]
                  }, availablePtu['id']);
                })]
              })
            })]
          })
        })]
      })
    });
  } else {
    null;
  }
}
var _default = exports["default"] = EquipmentConfig;